/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meta V8 Over API Specification
 * OpenAPI spec version: 0.0.8
 */

/**
 * 플랫폼 타입
 */
export type _RequestPlatform = (typeof _RequestPlatform)[keyof typeof _RequestPlatform];

export const _RequestPlatform = {
  APPLICATION: 'APPLICATION',
  BUSINESS: 'BUSINESS',
  CLOUD: 'CLOUD',
  DATABASE: 'DATABASE',
  HOST: 'HOST',
  KUBERNETES: 'KUBERNETES',
  MESSAGE_QUEUE: 'MESSAGE_QUEUE',
  NETWORK_DEVICE: 'NETWORK_DEVICE',
  RUM: 'RUM',
  WEBSERVER: 'WEBSERVER',
} as const;
